import React, { Component } from 'react'
import { graphql, gql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { validateRequired } from './../../libs/validation'
import { Padding } from '../UI/StyledComponents'
import { TextInput, BirthdayInput, SelectInput, UploadAvatar, Loader } from '../UI'
import Form from '../UI/Form'
import _ from 'lodash'
import { changePassword, getLogs } from '../../libs/authService'
import { NotificationManager } from 'react-notifications'
import LogTable from './LogTable'

class ProfileSettings extends Component {
  state = { error: null, successPassword: false, logs: [], pending: true, ips: {} }
  componentDidMount() {
    getLogs()
      .then(res => res.json())
      .then(body => {
        console.log('body', body)
        this.setState({ logs: Array.from(body).filter(item => item.type === 's'), pending: false })
      })
      .catch(err => {
        this.setState({ error: 'error' })
        NotificationManager.error(err.message, 'Error', 5000)
      })
  }
  hidePasswordAlert = () => {
    this.setState({ successPassword: false })
  }
  handleSubmit = (e, props) => {
    if (e.password === e.password_confrim && e.password.length > 3) {
      this.setState({ error: null })
      changePassword(e.password)
        .then(e => e.json())
        .then(body => NotificationManager.success('Passwoed changed', 'Success', 5000))
        .catch(err => NotificationManager.error('Cant change password', 'Error', 5000))
    } else {
      this.setState({ error: 'Passwords must match and contains at least 4 symbols' })
    }
  }
  render() {
    const { t } = this.props
    return (
      <div className="container">
        <div className="row">
          <div className="col-md-2 col-md-offset-2">
            <h4>Settings</h4>
          </div>
          <div className="col-md-6 ">
            <div className="panel panel-default" style={{ fontSize: '16px' }}>
              <div className="panel-body ">
                <Padding size="0px 39px">
                  <div className="row">
                    <h1>Edit Settings</h1>
                    <hr />
                    <Form
                      onSubmit={e => this.handleSubmit(e, this.props.user)}
                      submitBtnClassname="btn btn-lg btn-primary pull-right"
                      submitBtnName={'Update Password'}
                    >
                      <h3>Change Password</h3>
                      <div className="form-horizontal event__form-container" style={{ paddingTop: '10px' }}>
                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-4 control-label" style={{ textAlign: 'right' }}>
                            New Password
                          </label>
                          <div className="col-md-8 ">
                            <TextInput
                              id="password"
                              validationFuncs={[validateRequired]}
                              type="password"
                              simpleValue
                              isGroup={false}
                              placeholder="Type your new password"
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="sub-category" className="event__form-label col-md-4 control-label" style={{ textAlign: 'right' }}>
                            Confirm Password
                          </label>
                          <div className="col-md-8 ">
                            <TextInput
                              id="password_confrim"
                              type="password"
                              simpleValue
                              validationFuncs={[validateRequired]}
                              isGroup={false}
                              placeholder="Confirm your new password"
                            />
                          </div>
                        </div>
                      </div>
                      {this.state.error && <div className="text-danger text-right">{this.state.error}</div>}
                    </Form>
                    <hr style={{ marginTop: 110 }} />
                    <h3>Login history</h3>
                    {console.log('before render it', this.state, typeof this.state.logs)}
                    {!this.state.pending ? <LogTable logs={this.state.logs} /> : <Loader showLoader={true} />}
                    <button className="btn btn-lg btn-primary pull-right">Logout from all devices</button>
                    <hr style={{ marginTop: 75 }} />
                  </div>
                </Padding>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('profile'))
export default enhance(ProfileSettings)



// WEBPACK FOOTER //
// src/components/ProfileSettings/index.js